import script from "./StatsCommuterBenefitsQuery.vue?vue&type=script&lang=js"
export * from "./StatsCommuterBenefitsQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__